import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubble6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubble-6, message, chat"} maskId="square-filled-radius-0-stroke-1-IconBubble6"><path d="M7.5 3C4.46243 3 2 5.46243 2 8.5V21H16.5C19.5376 21 22 18.5376 22 15.5V8.5C22 5.46243 19.5376 3 16.5 3H7.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubble6;
